import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PermissionsService } from 'src/app/core/auth/permissions.service';

@Directive({
  selector: '[appHideIfOne]'
})
export class HideIfOneDirective {

  private hasView = false;

  constructor(private templateRef:TemplateRef<any>, private viewContainerRef:ViewContainerRef, private permissionService:PermissionsService) { }

  @Input() set appHideIfOne(permissions:string) {

    const isAuthorized = this.permissionService.hasOnePermission(permissions.split('|'));
    if(!isAuthorized && !this.hasView){
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (isAuthorized && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }
}